/**
Author - Vikrant Singh
Git - git@github.com:vikrantSingh97
**/

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import {ActionButton} from 'screens/commons';

import {ProgressBar} from 'components/ProgressBar';
import DocumentPreviewCard from 'components/DocumentPreviewCard';
import {isInAppWebview} from 'utils/ClientAppUtils';

const propTypes = {
  onSubmit: PropTypes.func.isRequired,
  skipStep: PropTypes.func.isRequired,
  agreementUrl: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  showSkipButton: PropTypes.bool.isRequired,
  partnerName: PropTypes.string,
};

const PartnerAgreement = ({
  onSubmit,
  skipStep,
  agreementUrl,
  isLoading,
  showSkipButton,
  partnerName,
}) => {
  const isInPartnerApp = isInAppWebview();

  const renderPdfOrDownloadButton = () => {
    if (isInPartnerApp) {
      return (
        <DocumentPreviewCard
          partnerName={partnerName}
          agreementUrl={agreementUrl}
          buttonText="View Agreement"
        />
      );
    }
    return <IframeContainer title="agreement" src={agreementUrl} />;
  };

  return isLoading ? (
    <LoaderContainer>
      <ProgressBar
        heading="Processing Agreement"
        subheading="Please wait while we prepare your agreement"
        waitTimeInSec={180}
        stopOnEndTime={true}
        stopOnEndMsg="Processing taking longer than expected. Please try again."
        showShadow={true}
        loadingTexts={[
          'Updating your information, Please do not close the window',
          'Preparing your agreement...',
          'This might take a few moments',
          'We are setting up your partnership details',
        ]}
      />
    </LoaderContainer>
  ) : (
    <PartnerAgreementWrapper>
      {/* {showSkipButton ? <HeaderText onClick={skipStep}>Skip</HeaderText> : null} */}
      <Container>
        <PartnerAgreementContentWrapper>
          {renderPdfOrDownloadButton()}
          <ButtonContainer>
            <ActionButton isDisabled={isLoading} buttonText="Accept & Sign" callback={onSubmit} />
          </ButtonContainer>
        </PartnerAgreementContentWrapper>
      </Container>
    </PartnerAgreementWrapper>
  );
};
const PartnerAgreementWrapper = styled.div`
  height: 100%;
  width: 100%;
  scroll-behavior: scroll;
  position: relative;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
`;

const PartnerAgreementContentWrapper = styled.div`
  width: 100%;
  margin-top: 2rem;
  flex: 1;
  min-height: 60vh;
  display: flex;
  flex-direction: column;
`;

const Container = styled.div`
  padding: 2.4rem 0;
  width: 90%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  height: calc(100% - 4rem);
  flex: 1;
`;

const IframeContainer = styled.iframe`
  border: 1px #7e7e7e solid;
  border-radius: 5px;
  width: 100%;
  flex: 1;
  min-height: 400px;
`;

const ButtonContainer = styled.div`
  margin-top: 1.5rem;
  width: 100%;
  display: flex;
  justify-content: center;
`;

const LoaderContainer = styled.div`
  height: 80vh;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 25px;
    height: unset;
  }
`;
PartnerAgreement.propTypes = propTypes;

export default PartnerAgreement;
